(() => {
  const OVERRIDE_STYLE_ID = 'facets-override-styles';

  function ensureOverrideStyles() {
    if (document.getElementById(OVERRIDE_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = OVERRIDE_STYLE_ID;
    style.textContent = `
      .facets--horizontal floating-panel-component.facets__panel-content,
      .facets--horizontal floating-panel-component.facets__inputs.facets__panel-content {
        top: 100% !important;
      }
    `;

    document.head.appendChild(style);
  }

  function isHorizontalFilterButton(trigger) {
    return (
      trigger instanceof HTMLElement &&
      trigger.matches('[data-disclosure-id][data-filter-style="horizontal"]') &&
      !trigger.closest('.facets--drawer, .facets.drawer, dialog-component.facets-block-wrapper--drawer')
    );
  }

  function closeFilterButton(trigger) {
    if (!(trigger instanceof HTMLElement)) return;

    const panelId = trigger.getAttribute('aria-controls');
    if (!panelId) return;

    const panel = document.getElementById(panelId);
    trigger.setAttribute('aria-expanded', 'false');

    if (panel) {
      panel.style.display = 'none';
      panel.setAttribute('hidden', '');
    }

    const caret = trigger.querySelector('.icon-caret');
    if (caret) {
      caret.classList.remove('icon-caret--expanded');
    }
  }

  function closeSiblingFilters(trigger) {
    const wrapper = trigger.closest('.facets__filters-wrapper');
    if (!wrapper) return;

    const siblings = wrapper.querySelectorAll('[data-disclosure-id][data-filter-style="horizontal"]');

    for (const sibling of siblings) {
      if (sibling !== trigger) {
        closeFilterButton(sibling);
      }
    }
  }

  function handleBeforeToggle(event) {
    const trigger = event.target.closest('[data-disclosure-id]');
    if (!isHorizontalFilterButton(trigger)) return;

    if (trigger.getAttribute('aria-expanded') !== 'true') {
      closeSiblingFilters(trigger);
    }
  }

  function normalizeOpenPanels() {
    const wrappers = document.querySelectorAll('.facets__filters-wrapper');

    for (const wrapper of wrappers) {
      const openButtons = wrapper.querySelectorAll(
        '[data-disclosure-id][data-filter-style="horizontal"][aria-expanded="true"]'
      );

      let keepFirstOpen = true;

      for (const button of openButtons) {
        if (keepFirstOpen) {
          keepFirstOpen = false;
          continue;
        }

        closeFilterButton(button);
      }
    }
  }

  function init() {
    ensureOverrideStyles();
    normalizeOpenPanels();
  }

  document.addEventListener('click', handleBeforeToggle, true);
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        handleBeforeToggle(event);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState !== 'loading') {
    init();
  }
})();
